
import Popup from 'vux/src/components/popup/index.vue'

export default {
name: "pur-requisition-list",
components:{Popup},
data(){
return{
tabIndex:1,
wrapperHeight:0,
allLoaded:false,
config:{
title:'采购申请',
url:'api/purRequisitionMat/page',
property: "createdDate",
inputCondition:{
placeholder:'采购申请编号',
searchCondition:'key',
rules:[{field:"code", option: "LIKE_ANYWHERE"}]
},
specialCondition: {
ignoreField: true
},
workflowSearchBean: {
searchType: "0",
workflowId: "1000060"
},




















},
list:[],
popupShow:false,
showDetail:{},
typeShowValueList:[],
purTypeList:[]
}
},
methods:{
getTabIndex(e){
this.tabIndex = e;
},
getList(e,met,bol){
this.$nextTick(()=>{
if(bol){
this.list = this.list.concat(e);
}else{
this.list = e;
}
if(met === 'top'){
this.$refs.loadmore.onTopLoaded();
}
if(met === 'bottom'){
this.$refs.loadmore.onBottomLoaded();
}
})
},
init: function() {

this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
},
loadTop(){
this.$refs.header.getlist(true);
},
loadBottom(){
this.$refs.header.getMore();
},
viewDetail(item){
console.log(item, item.requestId)
if(item.requestId){
this.goFlow(item.requestId)
}else{
this.popupShow = true;
this.showDetail = item;
console.log(this.showDetail)
}
},
getTypeValueList(){
this.$get('api/pur-requisition-type/all').then((res) => {
if(res){
this.typeShowValueList = [{name:'全部',code:null}];
res.forEach((item) => {
let obj = {
name:item.value,
code:item.code
};
this.typeShowValueList.push(obj);
});
this.config.selectConfig[0].list = this.typeShowValueList;
}
});
this.$get('api/dict-tables/search-with-list?dictCode=priceType').then((res) => {
if(res && res.dictItems){
this.purTypeList = [{name:'全部',code:null}];
res.dictItems.forEach((item) => {
let obj = {
name:item.value,
code:item.code
};
this.purTypeList.push(obj);
});
this.config.selectConfig[1].list = this.purTypeList;
}
})
},
goFlow(requestId){
this.$router.push('/workflow/'+requestId+'?component=PurRequisitionDrawerComponent')
}
},
mounted(){
this.init();
this.getTypeValueList();
this.$refs.header.getlist();
}
}



// WEBPACK FOOTER //
// ./src/page/purchase-requisition/pur-requisition-todo-list.vue